export default "__VITE_ASSET__CG_BBf9Q__"